//
// KPIGridLayoutMetrics.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/BIRDModel";

var KPIGridLayoutMetrics = createModule("BIRD::KPIGridLayoutMetrics", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        numberOfKPIs: 4,
        cellWidth: 5,
        numberOfVisibleRows: 4,
        numberOfColumns: 4,
        numberOfVisibleColumns: 4,
        cellHeight: 5,
        numberOfRows: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default KPIGridLayoutMetrics;
